
import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import InsertSubtemplateCommand from './insertsubtemplatecommand';

export default class InsertSubtemplateEditing extends Plugin {
  init() {
    const editor = this.editor;
    editor.commands.add( 'insertsubtemplate', new InsertSubtemplateCommand( editor ) );
  }
}
